/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Nosubscriptionsbody2Inputs */

const id_notifications_nosubscriptionsbody2 = /** @type {(inputs: Notifications_Nosubscriptionsbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda berlangganan tetapi belum membuat langganan perangkat. Gunakan tab "Pengaturan & Berlangganan" untuk membuat langganan pertama Anda.`)
};

const ms_notifications_nosubscriptionsbody2 = /** @type {(inputs: Notifications_Nosubscriptionsbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda dilanggan tetapi belum membuat sebarang langganan peranti. Gunakan tab "Persediaan & Langgan" untuk membuat langganan pertama anda.`)
};

const da_notifications_nosubscriptionsbody2 = /** @type {(inputs: Notifications_Nosubscriptionsbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du er abonneret men har ikke oprettet nogen enhedsabonnementer endnu. Brug fanen "Opsæt & Abonner" for at oprette dit første abonnement.`)
};

const de_notifications_nosubscriptionsbody2 = /** @type {(inputs: Notifications_Nosubscriptionsbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie sind abonniert, haben aber noch keine Geräteabonnements erstellt. Verwenden Sie die Registerkarte "Einrichten & Abonnieren", um Ihr erstes Abonnement zu erstellen.`)
};

const en_us2_notifications_nosubscriptionsbody2 = /** @type {(inputs: Notifications_Nosubscriptionsbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You are subscribed but haven't created any device subscriptions yet. Use the "Setup & Subscribe" tab to create your first subscription.`)
};

const es_es2_notifications_nosubscriptionsbody2 = /** @type {(inputs: Notifications_Nosubscriptionsbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estás suscrito pero aún no has creado suscripciones de dispositivo. Usa la pestaña "Configurar y suscribirse" para crear tu primera suscripción.`)
};

const es_mx2_notifications_nosubscriptionsbody2 = /** @type {(inputs: Notifications_Nosubscriptionsbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estás suscrito pero aún no has creado suscripciones de dispositivo. Usa la pestaña "Configurar y suscribirse" para crear tu primera suscripción.`)
};

const fil_notifications_nosubscriptionsbody2 = /** @type {(inputs: Notifications_Nosubscriptionsbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikaw ay naka-subscribe ngunit wala ka pang nagagawang device subscription. Gamitin ang tab na "Setup & Subscribe" para gumawa ng iyong unang subscription.`)
};

const fr_notifications_nosubscriptionsbody2 = /** @type {(inputs: Notifications_Nosubscriptionsbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous êtes abonné mais n'avez pas encore créé d'abonnement d'appareil. Utilisez l'onglet « Configuration et abonnement » pour créer votre premier abonnement.`)
};

const it_notifications_nosubscriptionsbody2 = /** @type {(inputs: Notifications_Nosubscriptionsbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sei iscritto ma non hai ancora creato alcuna sottoscrizione dispositivo. Usa la scheda "Setup e iscrizione" per creare la tua prima sottoscrizione.`)
};

const hu_notifications_nosubscriptionsbody2 = /** @type {(inputs: Notifications_Nosubscriptionsbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fel vagy iratkozva, de még nem hoztál létre eszköz feliratkozásokat. Használd a "Beállítás és feliratkozás" fület az első feliratkozás létrehozásához.`)
};

const nl_notifications_nosubscriptionsbody2 = /** @type {(inputs: Notifications_Nosubscriptionsbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je bent geabonneerd maar hebt nog geen apparaatabonnementen aangemaakt. Gebruik het tabblad "Instellen en abonneren" om je eerste abonnement aan te maken.`)
};

const no_notifications_nosubscriptionsbody2 = /** @type {(inputs: Notifications_Nosubscriptionsbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du er abonnert, men har ikke opprettet noen enhetsabonnementer ennå. Bruk fanen "Konfigurer og abonner" for å opprette ditt første abonnement.`)
};

const pl_notifications_nosubscriptionsbody2 = /** @type {(inputs: Notifications_Nosubscriptionsbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jesteś subskrybowany, ale nie utworzyłeś jeszcze żadnych subskrypcji urządzeń. Użyj zakładki "Konfiguruj i subskrybuj", aby utworzyć pierwszą subskrypcję.`)
};

const pt_br2_notifications_nosubscriptionsbody2 = /** @type {(inputs: Notifications_Nosubscriptionsbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você está inscrito, mas ainda não criou nenhuma assinatura de dispositivo. Use a guia "Configurar e assinar" para criar sua primeira assinatura.`)
};

const pt_notifications_nosubscriptionsbody2 = /** @type {(inputs: Notifications_Nosubscriptionsbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Está subscrito mas ainda não criou nenhuma subscrição de dispositivo. Use o separador "Configurar & Subscrever" para criar a sua primeira subscrição.`)
};

const ro_notifications_nosubscriptionsbody2 = /** @type {(inputs: Notifications_Nosubscriptionsbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ești abonat dar nu ai creat încă niciun abonament de dispozitiv. Folosește fila "Configurare și Abonare" pentru a crea primul abonament.`)
};

const fi_notifications_nosubscriptionsbody2 = /** @type {(inputs: Notifications_Nosubscriptionsbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Olet tilannut, mutta et ole vielä luonut laitetilauksia. Käytä "Asetukset ja tilaa" -välilehteä luodaksesi ensimmäisen tilauksesi.`)
};

const sv_notifications_nosubscriptionsbody2 = /** @type {(inputs: Notifications_Nosubscriptionsbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du prenumererar men har inte skapat några enhetsprenumerationer än. Använd fliken "Konfigurera & prenumerera" för att skapa din första prenumeration.`)
};

const vi_notifications_nosubscriptionsbody2 = /** @type {(inputs: Notifications_Nosubscriptionsbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn đã đăng ký nhưng chưa tạo đăng ký thiết bị nào. Sử dụng tab "Thiết lập & Đăng ký" để tạo đăng ký đầu tiên.`)
};

const tr_notifications_nosubscriptionsbody2 = /** @type {(inputs: Notifications_Nosubscriptionsbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonesiniz ancak henüz herhangi bir cihaz aboneliği oluşturmadınız. İlk aboneliğinizi oluşturmak için "Kurulum ve Abone Ol" sekmesini kullanın.`)
};

const cs_notifications_nosubscriptionsbody2 = /** @type {(inputs: Notifications_Nosubscriptionsbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jste přihlášeni, ale dosud jste nevytvořili žádné odběry zařízení. Použijte záložku "Nastavení a přihlášení" k vytvoření prvního odběru.`)
};

const bg_notifications_nosubscriptionsbody2 = /** @type {(inputs: Notifications_Nosubscriptionsbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вие сте абонирани, но все още не сте създали никакви абонаменти за устройство. Използвайте раздела "Настройка и абониране", за да създадете първия си абонамент.`)
};

const ru_notifications_nosubscriptionsbody2 = /** @type {(inputs: Notifications_Nosubscriptionsbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы подписаны, но ещё не создали ни одной подписки устройства. Используйте вкладку «Настройка и подписка», чтобы создать первую подписку.`)
};

const uk_notifications_nosubscriptionsbody2 = /** @type {(inputs: Notifications_Nosubscriptionsbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ви підписані, але ще не створили жодної підписки пристрою. Скористайтеся вкладкою «Налаштувати та підписатися», щоб створити першу підписку.`)
};

const ar_notifications_nosubscriptionsbody2 = /** @type {(inputs: Notifications_Nosubscriptionsbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أنت مشترك ولكن لم تقم بإنشاء أي اشتراكات جهاز بعد. استخدم علامة التبويب "الإعداد والاشتراك" لإنشاء اشتراكك الأول.`)
};

const hi_notifications_nosubscriptionsbody2 = /** @type {(inputs: Notifications_Nosubscriptionsbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आप सब्सक्राइब हैं लेकिन अभी तक कोई डिवाइस सब्सक्रिप्शन नहीं बनाया है।`)
};

const th_notifications_nosubscriptionsbody2 = /** @type {(inputs: Notifications_Nosubscriptionsbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณสมัครรับแล้วแต่ยังไม่ได้สร้างการสมัครรับอุปกรณ์ใด ๆ ใช้แท็บ "ตั้งค่าและสมัครรับ" เพื่อสร้างการสมัครรับครั้งแรกของคุณ`)
};

const ja_notifications_nosubscriptionsbody2 = /** @type {(inputs: Notifications_Nosubscriptionsbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`購読はしていますが、まだデバイスサブスクリプションを作成していません。「設定と購読」タブを使用して最初のサブスクリプションを作成してください。`)
};

const zh_cn2_notifications_nosubscriptionsbody2 = /** @type {(inputs: Notifications_Nosubscriptionsbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您已订阅但尚未创建任何设备订阅。请使用“设置与订阅”选项卡创建您的第一个订阅。`)
};

const zh_hant1_notifications_nosubscriptionsbody2 = /** @type {(inputs: Notifications_Nosubscriptionsbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您已訂閱但尚未建立任何裝置訂閱。請使用「設定與訂閱」索引標籤建立您的第一個訂閱。`)
};

const ko_notifications_nosubscriptionsbody2 = /** @type {(inputs: Notifications_Nosubscriptionsbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구독은 되어 있지만 아직 기기 구독을 생성하지 않았습니다. "설정 및 구독" 탭을 사용하여 첫 번째 구독을 생성하세요.`)
};

/**
* | output |
* | --- |
* | "You are subscribed but haven't created any device subscriptions yet. Use the \"Setup & Subscribe\" tab to create your first subscription." |
*
* @param {Notifications_Nosubscriptionsbody2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_nosubscriptionsbody2 = /** @type {((inputs?: Notifications_Nosubscriptionsbody2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Nosubscriptionsbody2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_nosubscriptionsbody2(inputs)
	if (locale === "ms") return ms_notifications_nosubscriptionsbody2(inputs)
	if (locale === "da") return da_notifications_nosubscriptionsbody2(inputs)
	if (locale === "de") return de_notifications_nosubscriptionsbody2(inputs)
	if (locale === "en-US") return en_us2_notifications_nosubscriptionsbody2(inputs)
	if (locale === "es-ES") return es_es2_notifications_nosubscriptionsbody2(inputs)
	if (locale === "es-MX") return es_mx2_notifications_nosubscriptionsbody2(inputs)
	if (locale === "fil") return fil_notifications_nosubscriptionsbody2(inputs)
	if (locale === "fr") return fr_notifications_nosubscriptionsbody2(inputs)
	if (locale === "it") return it_notifications_nosubscriptionsbody2(inputs)
	if (locale === "hu") return hu_notifications_nosubscriptionsbody2(inputs)
	if (locale === "nl") return nl_notifications_nosubscriptionsbody2(inputs)
	if (locale === "no") return no_notifications_nosubscriptionsbody2(inputs)
	if (locale === "pl") return pl_notifications_nosubscriptionsbody2(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_nosubscriptionsbody2(inputs)
	if (locale === "pt") return pt_notifications_nosubscriptionsbody2(inputs)
	if (locale === "ro") return ro_notifications_nosubscriptionsbody2(inputs)
	if (locale === "fi") return fi_notifications_nosubscriptionsbody2(inputs)
	if (locale === "sv") return sv_notifications_nosubscriptionsbody2(inputs)
	if (locale === "vi") return vi_notifications_nosubscriptionsbody2(inputs)
	if (locale === "tr") return tr_notifications_nosubscriptionsbody2(inputs)
	if (locale === "cs") return cs_notifications_nosubscriptionsbody2(inputs)
	if (locale === "bg") return bg_notifications_nosubscriptionsbody2(inputs)
	if (locale === "ru") return ru_notifications_nosubscriptionsbody2(inputs)
	if (locale === "uk") return uk_notifications_nosubscriptionsbody2(inputs)
	if (locale === "ar") return ar_notifications_nosubscriptionsbody2(inputs)
	if (locale === "hi") return hi_notifications_nosubscriptionsbody2(inputs)
	if (locale === "th") return th_notifications_nosubscriptionsbody2(inputs)
	if (locale === "ja") return ja_notifications_nosubscriptionsbody2(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_nosubscriptionsbody2(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_nosubscriptionsbody2(inputs)
	return ko_notifications_nosubscriptionsbody2(inputs)
});
export { notifications_nosubscriptionsbody2 as "notifications.noSubscriptionsBody" }